"use strict";var p=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var r=(s,i,t,o)=>{for(var e=o>1?void 0:o?h(i,t):i,l=s.length-1,a;l>=0;l--)(a=s[l])&&(e=(o?a(i,t,e):a(e))||e);return o&&e&&p(i,t,e),e};import{html as n}from"@spectrum-web-components/base";import{state as c}from"@spectrum-web-components/base/src/decorators.js";import{ifDefined as d}from"@spectrum-web-components/base/src/directives.js";import{property as u}from"@spectrum-web-components/base/src/decorators.js";import{DESCRIPTION_ID as m,PickerBase as b}from"@spectrum-web-components/picker";import"@spectrum-web-components/action-button/sp-action-button.js";import{ObserveSlotPresence as f}from"@spectrum-web-components/shared/src/observe-slot-presence.js";import{ObserveSlotText as $}from"@spectrum-web-components/shared/src/observe-slot-text.js";import"@spectrum-web-components/icons-workflow/icons/sp-icon-more.js";import y from"./action-menu.css.js";export class ActionMenu extends f($(b,"label"),'[slot="label-only"]'){constructor(){super(...arguments);this.selects=void 0;this.static=void 0;this.listRole="menu";this.itemRole="menuitem"}static get styles(){return[y]}get hasLabel(){return this.slotHasContent}get labelOnly(){return this.slotContentIsPresent}get buttonContent(){return[n`
                ${this.labelOnly?n``:n`
                          <slot
                              name="icon"
                              slot="icon"
                              ?icon-only=${!this.hasLabel}
                              ?hidden=${this.labelOnly}
                          >
                              <sp-icon-more class="icon"></sp-icon-more>
                          </slot>
                      `}
                <slot name="label" ?hidden=${!this.hasLabel}></slot>
                <slot name="label-only"></slot>
                <slot name="tooltip"></slot>
            `]}render(){return n`
            <sp-action-button
                aria-describedby=${m}
                ?quiet=${this.quiet}
                ?selected=${this.open}
                static=${d(this.static)}
                aria-haspopup="true"
                aria-controls=${d(this.open?"menu":void 0)}
                aria-expanded=${this.open?"true":"false"}
                aria-label=${d(this.label||void 0)}
                id="button"
                class="button"
                size=${this.size}
                @blur=${this.handleButtonBlur}
                @pointerdown=${this.handleButtonPointerdown}
                @focus=${this.handleButtonFocus}
                @click=${this.handleButtonClick}
                @keydown=${{handleEvent:this.handleEnterKeydown,capture:!0}}
                ?disabled=${this.disabled}
            >
                ${this.buttonContent}
            </sp-action-button>
            ${this.renderMenu} ${this.renderDescriptionSlot}
        `}update(t){t.has("invalid")&&(this.invalid=!1),super.update(t)}}r([u({type:String})],ActionMenu.prototype,"selects",2),r([u({type:String,reflect:!0})],ActionMenu.prototype,"static",2),r([c()],ActionMenu.prototype,"labelOnly",1);
//# sourceMappingURL=ActionMenu.js.map
